import * as React from 'react';
import { connect } from 'react-redux';

import MetricsInstagramPostForm from './MetricsInstagramPostForm';

import { updateReportMetrics } from 'modules/campaigns/components/campaign-report/metrics/reducers/campaign-report-metrics';

import type { AdminAnalytic, DeliverableAnalytic } from 'types';

type OwnProps = {
  deliverableId: number,
  analytic: DeliverableAnalytic | undefined | null
};

type DispatchProps = {
  dispatchUpdateDeliverableMetrics: (d: number, c: number, b: number, a: AdminAnalytic) => Promise<void>
};

type Props = OwnProps & DispatchProps;

class DeliverablesMetricsInstagramPostForm extends React.Component<Props> {
  handleSubmit = (metric: AdminAnalytic) => {
    const { deliverableId, analytic, dispatchUpdateDeliverableMetrics } = this.props;

    if (analytic) {
      return dispatchUpdateDeliverableMetrics(deliverableId, analytic.campaignId, analytic.id, metric);
    }

    return Promise.resolve();
  };

  render() {
    return (
      <MetricsInstagramPostForm
        analytic={this.props.analytic}
        onSave={this.handleSubmit}
      />
    );
  }
}

const mapDispatchToProps = (dispatch): DispatchProps => ({
  dispatchUpdateDeliverableMetrics: (deliverableId, campaignId, metricsId, data) =>
    dispatch(updateReportMetrics(deliverableId, campaignId, metricsId, data))
});

export default connect(null, mapDispatchToProps)(DeliverablesMetricsInstagramPostForm);
